import type { BulkActionReport } from "../../report-lists/reports/grid/toolbarActionsHelper";
import type { ArtifactRow } from "./artifactRow";

export const toBulkActionReport = (artifact: ArtifactRow): BulkActionReport => ({
  reportId: artifact.id,
  clientCode: artifact.clientCode,
  authorization: artifact.authorization,
});
